import React, { useState, useLayoutEffect, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { message } from 'antd';


import Page from '../layouts/Page';
import services from '../services';
import { obterAtualizacaoCadastral } from '../services/http/usuariosService';
import ModalAtualizacaoCadastral from '../components/ModalAtualizacaoCadastral';

// RD 96214: IdUser que já passou pela checagem de atualização cadastral nesta
// carga do SPA, para não repetir a chamada a cada troca de rota.
let atualizacaoConcluida = null;

const AtualizacaoCadastral = ({ children }) => {
    const usuario = services.storage.getUser();
    const idUser = usuario?.IdUser;
    // Admin nunca é bloqueado: não consulta a API.
    const isAdmin = usuario?.IsAdmin === 'True';
    const [dados, setDados] = useState(isAdmin || atualizacaoConcluida === idUser ? { pendente: false } : null);

    useEffect(() => {
        if (dados) return;
        obterAtualizacaoCadastral().then((resposta) => {
            if (resposta.fail) {
                // Fail-closed: sem confirmar o cadastro, a página não é liberada.
                console.error('Falha ao verificar atualização cadastral', resposta.errors);
                message.error('Não foi possível verificar seu cadastro. Recarregue a página para tentar novamente.');
                return;
            }
            if (!resposta.data.pendente) atualizacaoConcluida = idUser;
            setDados(resposta.data);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!dados) return null;

    if (dados.pendente) {
        return (
            <ModalAtualizacaoCadastral
                dados={dados}
                onConcluido={() => {
                    atualizacaoConcluida = idUser;
                    setDados({ pendente: false });
                }}
            />
        );
    }

    return children;
};

const PrivateRoutes = ({ component: Component, ...rest }) => {
    const [resultadoPesquisar, setResultadoPesquisar] = useState();
    const user = services.storage.getUser();
    const IsAdmin = user ? user.IsAdmin : undefined;
    const routers = ['/home', '/home-banners', '/configuracoes', '/dashboard', '/log', '/usuario', '/cadastros'];
    const search = (value) => {
        if (value.length > 0) {
            setResultadoPesquisar(value);
        }
    }

    return (
        <div>
            {(IsAdmin === 'False' && routers.some((router) => rest.path.startsWith(router))
                ? (<Redirect to={{ pathname: '/galeria-midia' }} />)
                : (<Route {...rest} render={props => {
                    const isAuthenticated = services.storage.get('isAuthenticated');
                    const hasToken = sessionStorage.getItem('authSistema');
                    
                    if (isAuthenticated && hasToken) {
                        return <AtualizacaoCadastral><Page search={search}> <Component {...props} resultadoPesquisar={resultadoPesquisar} />  </Page></AtualizacaoCadastral>;
                    } else {
                        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                    }
                }} />))
            }

        </div>

    )
}

export default PrivateRoutes;
